export default {
  addOns: 'Допълнения',
  availabilityDaySelector: 'Избор на дата за наличност',
  unavailable: 'Недостъпно',
  person: 'човек',
  people: 'хора',
  reserveNow: 'Резервирай сега',
  selectTime: 'Изберете час',
  select: 'Избери',
  reserve: 'Резервирай',
  time: 'Час',
  tier: 'Ниво',
  questions: 'Въпроси',
  addToCart: 'Добави в количката',
  checkout: 'Плащане',
  total: 'Общо',
  availability: 'Наличност',
  whatsIncluded: 'Какво е включено',
  showMore: 'Покажи повече',
  showLess: 'Покажи по-малко',
  session: 'Сесия',
  viewDetails: 'Преглед на детайли',
  findAvailability: 'Намери наличност',
  loading: 'Зареждане',
  capacity: 'Капацитет',
  noAvailableSessionsOnThisDate: 'Няма налични сесии на тази дата',
  noGroupAvailableOnThisDateAndTime:
    'Няма налични {{groupTitle}} на тази дата и час',
  noCollectionFound: 'Не е намерена колекция!',
  noResourceGroupFound: 'Не е намерена ресурсна група!',
  noData: 'Няма данни!',
  continue: 'Продължи',
  night: 'нощувка',
  nights: 'нощувки',
  noAvailableSessionsForSelectedDates:
    'Някои дати от вашия избор нямат налични сесии. Моля, изберете други дати.',
  from: 'от',
  dateRangeSelector: 'Избор на период от дати',
  priceTierRadioGroup: 'Избор на ниво на цена',
  startTime: 'Начален час',
  duration: 'Продължителност',
  lengthOfStay: 'Продължителност на престоя',
  startDate: 'Начална дата',
  endDate: 'Крайна дата',
  selectDates: 'Изберете дати',
  more: 'Още',
  selectStartTime: 'Изберете начален час',
  endTime: 'Краен час',
  selectEndTime: 'Изберете краен час',
  morning: 'Сутрин',
  afternoon: 'Следобед',
  save: 'Запази',
  selectDuration: 'Изберете продължителност',
  forLength: 'за {{length}}',
  moreDates: 'още {{count}}',
  addDate: 'Добави дата',
  start: 'Начало',
  end: 'Край',
  pickupFrom: 'Вземане от',
  returnBy: 'Връщане до',
  day: 'ден',
  days: 'дни',
  hour: 'час',
  hours: 'часа',
};
